import React from 'react';
import { bool, func, string } from 'prop-types';
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl';
import { SelectableOptionCard } from '@landtrustinc/design-system';

import { ExternalLink } from '..';
import SelectableOptionCardsSkeleton from '../SelectableOptionCardsSkeleton/SelectableOptionCardsSkeleton';

import css from './FieldTripInsuranceToggle.module.css';

const FieldTripInsuranceToggle = ({
  name,
  onChange,
  insuranceCost,
  insuranceOptionSelected,
  isLoading,
}) => {
  return (
    <div className={css.root}>
      <div className={css.header}>
        <h3 className={css.title}>
          <FormattedMessage id="FieldTripInsurance.insuranceLabel" />
        </h3>
        <div className={css.description}>
          <p className={css.descriptionText}>
            <strong>
              <FormattedHTMLMessage id="FieldTripInsurance.insuranceSubHeading1" />{' '}
            </strong>
            <FormattedHTMLMessage id="FieldTripInsurance.insuranceSubHeading2" />
            <br />
            <span className={css.descriptionText}>
              <FormattedMessage id="FieldTripInsurance.viewComplete" />{' '}
              <ExternalLink
                href="https://www.csatravelprotection.com/certpolicy.do?product=GR330"
                className={css.insuranceLink}
              >
                <FormattedMessage id="FieldTripInsurance.planDetails" />
              </ExternalLink>
            </span>
          </p>
        </div>
      </div>

      {isLoading ? (
        <SelectableOptionCardsSkeleton cardCount={2} />
      ) : (
        <div className={css.cards}>
          <SelectableOptionCard
            id={`${name}Yes`}
            title={
              <FormattedHTMLMessage
                id="FieldTripInsuranceToggle.toggleYes"
                values={{ price: insuranceCost }}
              />
            }
            subtitle={<FormattedHTMLMessage id="FieldTripInsurance.insuranceYesSubTextShort" />}
            selected={insuranceOptionSelected === true}
            onClick={() => onChange(true)}
          />

          <SelectableOptionCard
            id={`${name}No`}
            tone="neutral"
            title={<FormattedHTMLMessage id="FieldTripInsuranceToggle.toggleNo" />}
            subtitle={<FormattedHTMLMessage id="FieldTripInsurance.insuranceNoSubText" />}
            selected={insuranceOptionSelected === false}
            onClick={() => onChange(false)}
          />
        </div>
      )}

      <p className={css.disclosures}>
        <FormattedMessage id="FieldTripInsurance.insuranceDisclosuresText" />{' '}
        <ExternalLink
          href="https://www.generalitravelinsurance.com/customer/disclosures.html"
          className={css.disclosuresLink}
        >
          <FormattedMessage id="FieldTripInsurance.importantDisclosures" />
        </ExternalLink>
      </p>
    </div>
  );
};

FieldTripInsuranceToggle.propTypes = {
  name: string.isRequired,
  onChange: func,
  insuranceOptionSelected: bool,
  isLoading: bool,
};

FieldTripInsuranceToggle.defaultProps = {
  onChange: () => {},
  insuranceOptionSelected: null,
  isLoading: false,
};

export default FieldTripInsuranceToggle;
